"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSessionController = void 0;
/**
 * creates a session controller using provider session manager
 * @param manager SessionManager instance
 */
function createSessionController(manager) {
    return {
        /**
         * gets auth headers from session manager
         */
        getAuthToken() {
            return manager.getAuthToken();
        },
        /**
         * checks if the session is valid
         */
        isSessionValid() {
            return manager.isSessionValid();
        }
    };
}
exports.createSessionController = createSessionController;
//# sourceMappingURL=session-controller.js.map